import { LatestCommentPopover } from './LatestCommentPopover/LatestCommentPopover';
import { LatestReviewSummaryPopoverMapper } from './LatestReviewSummaryPopover/LatestReviewSummaryPopoverMapper';

export const BasePopover = (props) => {
  return (
    <div className='base-popover'>
      <div className='base-header'>
        <h3>
          {props.patientInfo.patientName ||
            props.patientInfo.fullName ||
            props.patientInfo.patient_name}
        </h3>
      </div>
      <div className='base-parent'>
        <div className='base-column-1'>
          <div className='base-quick-dets'>
            <p>
              Account #:{' '}
              {props.patientInfo.accountNumber ||
                props.patientInfo._original.patientAccountNumber}
            </p>
          </div>
          <div className='base-quick-links'>
            <div
              onClick={(e) => {
                e.preventDefault();
                props.patientDetails(props.patientInfo);
              }}
            >
              VIEW PATIENT DETAILS
            </div>
          </div>
          <div className='base-bottom'></div>
        </div>
        {/* comment part of popover will only show for DF clients */}
        {props.patientInfo.entityid.length > 4 && (
          <LatestCommentPopover
            patientInfo={props.patientInfo}
            patientDetails={props.patientDetails}
            goToMessageFeed={props.goToMessageFeed}
          />
        )}

        <LatestReviewSummaryPopoverMapper
          patientInfo={props.patientInfo}
          patientDetails={props.patientDetails}
        />
      </div>
    </div>
  );
};
